import React from 'react';
import './App.css';
import HomePage from './containers/HomePage';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <HomePage />
      <Footer />
    </div>
  );
}

export default App;
